<!-- Query Form -->
<form class="gallery-filters" [formGroup]="queryForm" *ngIf="(searchMode$ | async) === gallerySearchMode.Query">
  <!-- Primary Category -->
  <select class="input mr-2 w-25" autofocus formControlName="primaryCategory">
    <option *ngFor="let category of (primaryCategoryOptions$ | async)" [value]="category">{{ category }}</option>
  </select>

  <!-- Secondary Category -->
  <select class="input mr-2 w-25" formControlName="secondaryCategory" *ngIf="(secondaryCategoryOptions$ | async)?.length">
    <option *ngFor="let category of (secondaryCategoryOptions$ | async)" [value]="category">{{ category }}</option>
  </select>

  <!-- Toggle Search Mode -->
  <button type="button" app-button buttonTheme="light" (click)="toggleSearchMode(gallerySearchMode.Path)">...or specify file path</button>
</form>

<!-- Path Form -->
<form class="gallery-filters" [formGroup]="pathForm" *ngIf="(searchMode$ | async) === gallerySearchMode.Path">
  <input type="text" class="input mr-2 w-75" formControlName="path" placeholder="primary/secondary/name">

  <!-- Toggle Search Mode -->
  <button type="button" autofocus app-button buttonTheme="light" (click)="toggleSearchMode(gallerySearchMode.Query)">Cancel</button>
</form>